export default __webpack_public_path__ + "static/media/bg.7fe61454.png";